import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function Story() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.2 });

  return (
    <section className="py-32 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        <div 
          ref={ref}
          className={`grid lg:grid-cols-2 gap-16 items-center transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
          }`}
        >
          {/* Image */}
          <div className="relative">
            <div className="aspect-[4/5] w-full overflow-hidden">
              <img
                src="https://static.readdy.ai/image/6d9cd499b3569668e27a60fbbc899b03/44b7f5b07ca2fbb7d57acd45bff73d25.png"
                alt="愛と寄り添い"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Content */}
          <div className="space-y-10">
            <div className="space-y-6">
              <h3 className="text-sm tracking-[0.3em] text-stone-500 font-light" style={{ fontFamily: 'Cormorant, serif' }}>
                STORY
              </h3>
              
              <h2 className="text-4xl md:text-5xl leading-relaxed" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 400, color: '#705e44' }}>
                <span className="md:hidden">
                  ウルオイ、<br />サラサラ<br />ホワイトリリィの<br />優しい香り
                </span>
                <span className="hidden md:inline">
                  ウルオイ、サラサラ<br />ホワイトリリィの<br />優しい香り
                </span>
              </h2>
            </div>

            <div className="space-y-8" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 400, color: '#705e44' }}>
              <div className="space-y-4 text-lg leading-relaxed">
                <p className="border-l-2 border-stone-300 pl-6">
                  「強い香りは嫌」
                </p>
                <p className="border-l-2 border-stone-300 pl-6">
                  「仕上がりは妥協したくない」
                </p>
                <p className="border-l-2 border-stone-300 pl-6">
                  「安心して使いたい」
                </p>
              </div>

              <div className="pt-6 space-y-6 text-base leading-loose">
                <p>
                  Deaiwoは飼い主の悩みに<br />
                  スキンケア発想で寄り添います。
                </p>
                <p className="text-stone-600">
                  人の肌を整える化粧品ブランドならではのペットケア。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
